import { render } from "./App.vue?vue&type=template&id=94213a76"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=94213a76&lang=scss"

import exportComponent from "C:\\Users\\Benjamin\\Desktop\\Hudplejeklinikken Esbjerg\\code\\hpke\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__